import tokens from '@/PrimeVue/customDesignTokens';

export default {
  colorScheme: {
    light: {
      shadow: tokens.primitive.shadows.none,
      background: 'white'
    }
  }
};